module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/point_photowedding_01-0f293b5c021eebd9f594560ed1ad9821.webp";